export default __webpack_public_path__ + "static/media/Integracao_XP_B3.635b7422.gif";